import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Box, Button, Collapse, Dialog, DialogActions, DialogTitle, LinearProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import FileUploadList from '../components/FileUploadList';
import FolderUploadExists from '../components/FolderUploadExists';
import FolderUploadInput from '../components/FolderUploadInput';
import { useFileUploadManager } from '../hooks/useFileUploadManager';
import { useFileUploader } from '../hooks/useFileUploader';
const FolderUploadDialog = props => {
    const { parentFolder, asMultipleFiles = false, folderInputRef: folderInputRefProp, onDismiss, onCreateFolder } = props;
    const folderInputRef = useRef(null);
    const cancelCallbackRef = useRef();
    const [open, setOpen] = useState(false);
    const [error, setError] = useState();
    const [folder, setFolder] = useState();
    const [didFind, setDidFind] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [folderExists, setFolderExists] = useState(false);
    const uploader = useFileUploader();
    const manager = useFileUploadManager();
    const folderName = useMemo(() => {
        const { files } = manager;
        if (!(files.length > 0)) {
            return;
        }
        const path = files[0].webkitRelativePath || '';
        const index = path.indexOf('/');
        return index > -1 ? path.slice(0, index) : '';
    }, [manager]);
    const dismiss = () => {
        var _a;
        (_a = cancelCallbackRef.current) === null || _a === void 0 ? void 0 : _a.call(cancelCallbackRef);
        setOpen(false);
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(manager.progress, folder);
    };
    useLayoutEffect(() => {
        const el = folderInputRef.current;
        if (el) {
            el.directory = !asMultipleFiles;
            el.webkitdirectory = !asMultipleFiles;
        }
    }, [asMultipleFiles]);
    useEffect(() => {
        setOpen(manager.items.length > 0);
    }, [manager]);
    // clear state
    useEffect(() => {
        if (!open) {
            manager.clear();
            setFolder(undefined);
            setError(undefined);
            setDidFind(false);
            setIsLoading(false);
            setFolderExists(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    const dismissButton = (React.createElement(Button, { variant: 'outlined', onClick: dismiss }, "Dismiss"));
    const errorAlert = (React.createElement(Collapse, { in: !!error, style: { minHeight: 'unset' } },
        React.createElement(Box, { mx: 3, mt: 1 },
            React.createElement(Alert, { severity: 'error' }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.'))));
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { hidden: true, multiple: true, type: 'file', ref: ref => {
                folderInputRef.current = ref;
                if (folderInputRefProp) {
                    folderInputRefProp.current = ref;
                }
            }, onChange: event => {
                const { files } = event.target;
                if (files && files.length > 0) {
                    manager.add(Array.from(files));
                }
                // clear value
                if (folderInputRef.current) {
                    folderInputRef.current.value = '';
                }
            } }),
        React.createElement(Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: dismiss },
            isLoading && React.createElement(LinearProgress, null),
            React.createElement(DialogTitle, null, folder ? 'Upload Files' : 'Destination Folder'),
            open && !didFind && !folder && (React.createElement(FolderUploadExists, { content: errorAlert, actions: dismissButton, folderName: folderName, parentFolder: parentFolder, onError: setError, onLoad: setIsLoading, onSelect: (folder, folderExists) => {
                    setDidFind(true);
                    setFolder(folder);
                    setFolderExists(folderExists);
                } })),
            didFind && !folder && (React.createElement(FolderUploadInput, { content: errorAlert, actions: dismissButton, folderName: folderName, parentFolder: parentFolder, createOnMount: !folderExists, onError: setError, onLoad: setIsLoading, onSelect: (folder, created) => {
                    setError(undefined);
                    setFolder(folder);
                    if (folder && created) {
                        onCreateFolder === null || onCreateFolder === void 0 ? void 0 : onCreateFolder(folder);
                    }
                } })),
            folder && (React.createElement(FileUploadList, { folder: folder, manager: manager, uploader: uploader, renderActions: ({ progress, uploadAllButton, cancelAll }) => {
                    cancelCallbackRef.current = cancelAll;
                    return (React.createElement(React.Fragment, null,
                        errorAlert,
                        React.createElement(DialogActions, null,
                            React.createElement(Button, { variant: 'outlined', onClick: dismiss, disabled: progress.uploading > 0 }, "Dismiss"),
                            uploadAllButton)));
                } })))));
};
export default FolderUploadDialog;
//# sourceMappingURL=FolderUploadDialog.js.map